<div class="container">
    <form class="mt-3 mx-auto">
        <div class="mb-3 row">
          <div class="col">
            <h3>Pesquisa</h3>
          </div>
          <div class="col-auto">
            <button class="btn btn-danger no-margin" type="button"
              ngbTooltip="Fechar" [routerLink]="['../../']"><i>
              </i> Fechar</button>
          </div>
          <div class="col-auto">
            <button class="btn btn-success no-margin" type="button"
              (click)="salvar()"
              ngbTooltip="Tela para cadastro de programa permitido por cesta."><i>
              </i> Salvar</button>
          </div>
        </div>
      </form>
    <h5>Habilitação de programa permitido por cesta</h5>
    <div *ngIf="dominioProgramas; else carregando">
        <table class="table table-hover table-layout-fixed">
            <thead>
                <tr>
                    <th scope="col" style="width: 5%;"></th>
                    <th scope="col" [ngClass]="{'width-80': modalidade?.utilizaIndicadorEscoParaProgramasAceitos, 'width-95': !modalidade?.utilizaIndicadorEscoParaProgramasAceitos}">Código *</th>
                    <th scope="col" style="width: 15%;" *ngIf="modalidade?.utilizaIndicadorEscoParaProgramasAceitos"> <b> ESCO&ensp;</b>
                        <i class="fa fa-question-circle help-subtitulo" ngbTooltip="Tipo de sociedade de serviços de energia" placement="top-right"></i> </th>
                    <th scope="col" style="width: 10%;"><b> Aceita PF&ensp;</b></th>
                    <th scope="col" style="width: 15%;"><b> Desconsiderar prazo&ensp;</b></th>
                    <th scope="col" style="width: 10%;"><b> Abono ECG&ensp;</b></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let programa of programasPermitidos; let i = index">
                    <td>
                        <span><a (click)="removerPrograma(i)"><i class="fa fa-trash cursor-pointer"></i></a></span>
                    </td>
                    <td>
                      <ng-select
                        id="tipoGarantia"
                        name="tipoGarantia"
                        [items]="dominioProgramas"
                        bindLabel="id"
                        bindValue="id"
                        placeholder="(selecione um código de programa)"
                        (change)="atribuirPrograma($event, i)">
                        <ng-template ng-label-tmp let-item="item">
                            {{item.id}} - {{item.descricaoPrograma}}
                          </ng-template>
                          <ng-template ng-option-tmp let-item="item" container="body">
                            {{item.id}} - {{item.descricaoPrograma}}
                          </ng-template>
                      </ng-select>
                    </td>
                    <td *ngIf="modalidade?.utilizaIndicadorEscoParaProgramasAceitos" class="align-middle esco">
                        <input class="form-check checkbox-gigante m-0" 
                          (change)="atribuirEscoPrograma($event.target.checked, i)" 
                          type="checkbox" 
                          id="esco">
                    </td>
                    <td class="align-middle text-center">
                        <div class="d-flex align-items-center justify-content-center gap-1">                        
                            <input class="form-check checkbox-gigante m-0" 
                              (change)="atribuirAceitaBeneficiarioPf($event.target.checked, i)" 
                              type="checkbox"
                              [disabled]="aceitaBeneficiarioPessoaFisicaRepasse()"
                              id="aceitaBeneficiarioPF">

                            <i *ngIf="aceitaBeneficiarioPessoaFisicaRepasse()"
                              class="fa fa-question-circle help-subtitulo"
                              placement="top-right"
                              ngbTooltip="A opção 'Aceita Beneficiário Pessoa Física - Repasse' já está ativa na modalidade.">
                            </i>
                        </div>
                    </td>                    
                    <td class="align-middle text-center">
                        <input class="form-check checkbox-gigante m-0" 
                          (change)="atribuirDesconsiderarPrazo($event.target.checked, i)" 
                          type="checkbox"
                          id="atribuirDesconsiderarPrazo">
                    </td>                    
                    <td class="align-middle text-center">
                        <input class="form-check checkbox-gigante m-0" 
                          (change)="atribuirAbonoEcg($event.target.checked, i)" 
                          type="checkbox"
                          id="atribuirAbonoEcg">
                    </td>                    
                </tr>
            </tbody>
        </table>
        <a (click)="adicionarPrograma()" *ngIf="programasPermitidos.length < 10 "><i class="fa fa-plus-circle cursor-pointer"></i></a>
    </div>

    <ng-template #carregando>
        <div class="loading-pesquisa">
            <i class="bn-loading"></i>
        </div>
    </ng-template>
</div>